import { Box, Flex, Text } from "@chakra-ui/react";

const ReadingOrderEndItem = ({ children }) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      py="3"
      borderBottomWidth="1px"
      borderBottomColor="gray.900"
    >
      <Box px="4">
        <Text color="gray.500" fontSize="0.75em">
          {children}
        </Text>
      </Box>
    </Flex>
  );
};

export default ReadingOrderEndItem;
